async function quickcart() {

  let trigger = document.querySelector('.quickcart_trigger');
  // let triggerMobile = document.querySelector('#quickcart_trigger_mobile');
  let QC = document.querySelector('.quickcart');
  let listing = QC.querySelector('.listing');
  let menuList = document.querySelector('.c-site-header__list');

  let updateButton = QC.querySelector('.update');

  let QCnotice = document.querySelector('#quickcartnotice');

  // Get the current cart
  var cart = await getCart();

  let QCopen = false;
  let breakpoint = 720;

  if(trigger && QC) {  
    
    triggerInit();
    headerInit();
    footerInit();
    closureBackingInit();
    makeListing();
    updateCartButtonInit();
    addToCartTrigger();
    cartpageRemlinksClickToReloadSideCart();
    
    //wait a moment for cart to build
    setTimeout(()=>{
      refreshOnRemovalAction();
    },1000)

    checkForQueryTrigger();

    let windowWidth = $(window).width();
    screenWidthCheckCloseCart(breakpoint);
    
  }


  //  New feature. If the query string "?cart=reload" is in the URL, open the cart after a delay.
  function checkForQueryTrigger () {
    
    let params = new URL(document.location).searchParams;
    let recentAddToCart = params.get("cart");
    
    let openDelay = 1000;
    let closeDelay = 6000 + openDelay;
    
    if(recentAddToCart == 'reload') {

      let cartNotHovered = true;
      let QCcontent = QC.querySelector('.content');
      
      setTimeout( ()=>{
        openQuickCart();
        handleCartClose();
      }, openDelay );

      QCcontent.addEventListener('mouseenter', ()=>{
        cartNotHovered = false;
      });

      function handleCartClose() {
        setTimeout( ()=>{
          if(cartNotHovered) {
            closeQuickCart();
          }
        }, closeDelay );
      }
      
    }
  }


  function headerInit() {
    let QCcloseIcon = QC.querySelector('.close');
    if(QCcloseIcon) {
      QCcloseIcon.addEventListener('click', ()=>{
        closeQuickCart();
      });
    }
  }

  function footerInit() {
    let footer = QC.querySelector('.footer');
    if(footer) {

      let continueText = QC.querySelector('.continue');
      
      continueText.addEventListener('click', ()=>{
        closeQuickCart();
      });
    }
  }

  function triggerInit() {
    trigger.addEventListener('click', (e)=>{
      e.preventDefault();
      if(QCopen == true) {
        closeQuickCart();
      } else {
        openQuickCart();
      }
    });

  }

  function refreshOnRemovalAction() {
    let getAllRemoves = QC.querySelectorAll('.remove');
    // console.log("Get all Removes",getAllRemoves);
    if(getAllRemoves.length > 0) {
      getAllRemoves.forEach((rem)=>{
        rem.addEventListener('click',()=>{
          console.log('quick cart removal button clicked');
          // wait a moment then refresh
          setTimeout(()=>{
            location.reload();  
          },600)
          
        })
      });
    }
  }
  

  function openQuickCart() {
    QC.classList.add('active');
    menuList.classList.add('alt');
    QCopen = true;
  }

  function closeQuickCart() {
    QC.classList.remove('active');
    menuList.classList.remove('alt');
    QCopen = false;
  }

  function closureBackingInit() {
    let cBacking = QC.querySelector('.closureBacking');
    cBacking.addEventListener('click',()=>{
      closeQuickCart();
    })
  }

  function quickcartNoticeTrigger() {
    if(QCnotice) {

      QCnotice.classList.add('active');

      setTimeout( ()=> {
        QCnotice.classList.remove('active');
      },1200)
      
    }
  }

  function makeCartEntry(theItemID,itemTitle,itemOptions,itemProperties,itemPrice,itemOrigPrice,itemComparePrice,itemImage,itemQty,itemURL,itemDiscounts) {
    let newEntry = document.createElement("div");
    newEntry.classList.add('entry');
    newEntry.dataset.itemid = theItemID;

    let lCol = document.createElement("div");
    let rCol = document.createElement("div");
    lCol.classList.add('left', 'col');
    rCol.classList.add('right', 'col')
    newEntry.append(lCol);
    newEntry.append(rCol);

    let daImageLinkWrapper = document.createElement("a");
    daImageLinkWrapper.setAttribute('href', itemURL);
    let daImage = document.createElement("img");
    daImage.src = itemImage;
    daImageLinkWrapper.append(daImage);
    lCol.append(daImageLinkWrapper);
  
    let itemOptionsListing = '';
    if(itemOptions) {
      if(itemOptions[0]['name'] && itemOptions[0]['name'] != 'Title') {
        itemOptionsListing = itemOptions[0]['name'] + ': ' + itemOptions[0]['value'];
      }
    }

    let itemPropertiesListing = '';
    if(itemProperties) {
      itemPropertiesListing = Object.values(itemProperties);
    }
    
    let itemDiscountsListing = '';
    if(itemDiscounts.length > 0) {
      // itemDiscountsListing = itemDiscounts[0]['title'] + ':' + ' -' + makePrice(itemDiscounts[0]['amount']);
      itemDiscountsListing = itemDiscounts[0]['title'];
    }

    let rTitleLinkWrapper = document.createElement("a");
    rTitleLinkWrapper.setAttribute('href', itemURL);
    let rTitle = document.createElement("div");
    rTitleLinkWrapper.append(rTitle);
    let rPrice = document.createElement("div");
    let rInfo = document.createElement("div");
    
      rTitleLinkWrapper.classList.add('title', 'col');
      rTitle.appendChild(document.createTextNode(itemTitle));
      let optionArea = document.createElement("div");
      optionArea.classList.add('optionarea');
      optionArea.appendChild(document.createTextNode(itemOptionsListing));
      rTitle.appendChild(optionArea);

        let propertiesArea = document.createElement("div");
        propertiesArea.classList.add('propertiesarea');
        propertiesArea.appendChild(document.createTextNode(itemPropertiesListing));
        rTitle.appendChild(propertiesArea);

      
    
      rPrice.classList.add('price', 'col');

        let priceNode = document.createTextNode(makePrice(itemPrice));
    
        if(itemOrigPrice > itemPrice) {

          let priceOrigNodeWrapper = document.createElement("span");
          let priceOrigNode = document.createTextNode(makePrice(itemOrigPrice));
          priceOrigNodeWrapper.appendChild(priceOrigNode);
          priceOrigNodeWrapper.classList.add('original');
          rPrice.appendChild(priceOrigNodeWrapper);
          
          let rDiscNodeWrapper = document.createElement("span");
          let discNode = document.createTextNode(makePrice(itemPrice));
          rDiscNodeWrapper.appendChild(discNode);
          rDiscNodeWrapper.classList.add('originalPrice');

          rPrice.classList.add('discountedPrice');
          
        }

        rPrice.appendChild(priceNode);
    
      rInfo.classList.add('info', 'col');
      if(itemDiscounts.length > 0) {
        let rDiscountListingWrapper = document.createElement("div");
        rDiscountListingWrapper.classList.add('discounts');
        rInfo.appendChild(rDiscountListingWrapper);
        rDiscountListingWrapper.appendChild(document.createTextNode(itemDiscountsListing));
      }
      
    rCol.append(rTitleLinkWrapper);
    rCol.append(rPrice);
    rCol.append(rInfo);
    
    
    let rQty = document.createElement("div");
    rQty.classList.add('qty', 'col');
    let rQtyWrap = document.createElement("div");
      rQtyWrap.classList.add('wrap', 'qtywrap');
    let rQtyMin = document.createElement("div");
      rQtyMin.classList.add('min', 'shift');
      let minText = document.createTextNode("-");
      rQtyMin.appendChild(minText);
    let rQtyplus = document.createElement("div");
      rQtyplus.classList.add('plus', 'shift');
      let plusText = document.createTextNode("+");
      rQtyplus.appendChild(plusText);
    let rQtyInput = document.createElement("input");
      rQtyInput.setAttribute('type', 'number');
      rQtyInput.setAttribute('max', '99');
      let initVal = 0;
      if(itemQty > 0) {
        initVal = itemQty;
      }
      rQtyInput.setAttribute('value', initVal);
    
    rCol.append(rQty);
      rQty.append(rQtyWrap);
        rQtyWrap.append(rQtyMin);
        rQtyWrap.append(rQtyInput);
        rQtyWrap.append(rQtyplus);
    
    let rRemove = document.createElement("span");
      rRemove.classList.add('remove', 'col');
      rRemove.dataset.itemid = theItemID;
      let removeText = document.createTextNode("Remove");
      rRemove.appendChild(removeText);
    rCol.append(rRemove);
    
    listing.append(newEntry);
    
  }

  async function makeListing() {

    // console.log('makeListing');
    
    let itemID,itemTitle,itemOptions,itemPrice,itemQty,itemImage;

    var cart = await getCart();
    let cartItems = cart.items;

    if(cart.item_count > 0) {
      QC.classList.remove('empty');
    } else {
      QC.classList.add('empty');
    }

    let qCartTrigger = document.querySelector('.quickcart_trigger');
    let qCartTriggerNumberSpan = qCartTrigger.querySelector('.js-cart-count');
    let goToCartButton = document.querySelector('#quickcartGoToCartNumberSpan');
    qCartTriggerNumberSpan.textContent = cart.item_count;
    if(goToCartButton) {
      goToCartButton.textContent = cart.item_count;
    }

    let oldCartButton = document.querySelector('#oldCartButton');
    if(oldCartButton) {
      let oldCartButtonNumberSpan = oldCartButton.querySelector('.js-cart-count');
      oldCartButtonNumberSpan.textContent = cart.item_count;
    }

    let mobileCartIcon = document.querySelector('.c-site-header__cart');
    let mobileCartIconNumberSpan = mobileCartIcon.querySelector('.js-cart-count');
    mobileCartIconNumberSpan.textContent = cart.item_count;
    

    // console.log('Cart items...');
    cartItems.forEach((theItem)=>{
      
      // console.log(theItem);
      
      itemID = theItem.id;
      itemTitle = theItem.product_title;
      itemOptions = theItem.options_with_values;
      itemDiscounts = theItem.discounts;

      itemProperties = theItem.properties;

      // console.log('Final Price: ' + theItem.final_price);
      let fPrice = theItem.final_price;
      itemPrice = parseInt(fPrice);

      let oPrice = theItem.original_price;
      let itemOrigPrice = parseInt(oPrice);

      itemComparePrice = theItem.compare_at_price;
      itemImage = theItem.featured_image.url;
      itemQty = theItem.quantity;
      itemURL = theItem.url;

      makeCartEntry(itemID,itemTitle,itemOptions,itemProperties,itemPrice,itemOrigPrice,itemComparePrice,itemImage,itemQty,itemURL,itemDiscounts);
    })

    setTimeout( ()=>{
      qtyChanges();
      removeButtons();
    }, 800);
    
    displaySubtotal(cart.items_subtotal_price);   
    
  }

  

  function removeButtons() {
    if(listing) {
      let allRemoves = listing.querySelectorAll('.remove');
      if(allRemoves.length > 0) {
        allRemoves.forEach((remove)=>{
          remove.addEventListener('click',()=>{
            let thisID = remove.dataset.itemid;
            console.log("Trying to remove" + thisID);
            removeItem(thisID);
            reloadCart();
          });
        });
      }
    }
  }

  function qtyChanges() {
    if(listing) {
      
      let allQtyWraps = QC.querySelectorAll('.qtywrap');
      if(allQtyWraps.length > 0) {
        
        allQtyWraps.forEach((wrap)=>{
          let qty = wrap.querySelector('input');
          let down = wrap.querySelector('.min');
          let up = wrap.querySelector('.plus');
  
          down.addEventListener('click', ()=> {
            shiftqty('down');
          })
          up.addEventListener('click', ()=> {
            shiftqty('up');
          })
          qty.addEventListener('click', ()=>{
            qty.select();
          })
          qty.addEventListener('input', ()=>{
            toggleUpdateButton('show');
          })

          function shiftqty(direction) {
            if(direction == 'up') {
              qty.value = parseInt(qty.value) + 1;
              toggleUpdateButton('show');
            }
            if(direction == 'down') {
              if(qty.value == 0) {
                qty.value = 0;
              } else {
                qty.value = parseInt(qty.value) - 1;
                toggleUpdateButton('show');
              }
            }
          }
          
        })
      
      }
    }
  }

  function toggleUpdateButton(type) {
    if(updateButton) {
      if(type == 'show') {
        if(!updateButton.classList.contains('active')) {
          updateButton.classList.add('active');
        }
      } else {
        updateButton.classList.remove('active');
      }
    }
  }

  function updateCartButtonInit() {
    if(updateButton) {
      updateButton.addEventListener('click',()=>{
        updateCartQty();
        setTimeout(()=>{
          reloadCart();
          // If on product page, reload page to lock regenerate addtocart maxqty lock
          if (window.location.pathname.indexOf('/products/') !== -1) {
            location.reload();
          }
        },800);
      })
    }
  }

  function reloadCart() {

    // if we'e on the cart page, just refresh instead
    if (window.location.pathname.indexOf('/cart') !== -1) {
      setTimeout( ()=>{
        location.reload();  
      },850);
    }
    
    QC.classList.add('reload');
    listing.classList.add('reload');
    
    //Empty the listing
    setTimeout(()=>{
      $( "#quickcartlisting" ).empty(); // Empty out listing
    },200)
    
    //Rebuild listing
    setTimeout(()=>{
      makeListing();
    },300)
    
    // reveal new cart
    setTimeout(()=>{
      QC.classList.remove('reload');
      listing.classList.remove('reload');
    },500)
    
  }

  //Listen for new products being added via a raditional add to cart button.
  function addToCartTrigger() {

    // console.log('AddToCartTrigger Ready');

    
    let checkOrderTypeExists = document.querySelector('#order-type');
    
    let prodButtonArea = document.querySelector('.newbuttonarea');
    
    if(prodButtonArea) {
      let addCartButton = prodButtonArea.querySelector('button[type="submit"]');
      
      if(addCartButton) {
        
        addCartButton.addEventListener('click',(e)=>{

          e.preventDefault();

          let productID = document.querySelector('#productVarID').value;
          let productQty = document.querySelector('#Quantity').value;
          let productProperties = {};

          if(checkOrderTypeExists) {
            productProperties = {
              "Product Type": checkOrderTypeExists.value
            }
            let quickName = 'addingProductType_' + checkOrderTypeExists.value;
            gtag('event', quickName);
          }

          console.log('adding product to cart');
          addCartButton.classList.add('loading');

          
          
          // Send product to cart.
          console.log("adding to cart....");
          const lineItem = addItem(productID, productQty, productProperties);
          lineItem.then((value) => {
            console.log('Response success');
            reloadCart();
            setTimeout( ()=>{
              // addCartButton.classList.remove('loading');
              // openQuickCart();
              reloadLocationToResetQtyData();
            }, 3000);
          });
          

          // quickcartNoticeTrigger();

          function reloadLocationToResetQtyData() {
            let newLocation =  addParam(window.location.href, 'cart', 'reload');
            window.location.href = newLocation;
          }
        });
      }

      function addParam(url, param, value) {
        var a = document.createElement('a'), regex = /(?:\?|&amp;|&)+([^=]+)(?:=([^&]*))*/g;
        var match, str = []; a.href = url; param = encodeURIComponent(param);
        while (match = regex.exec(a.search))
           if (param != match[1]) str.push(match[1]+(match[2]?"="+match[2]:""));
        str.push(param+(value?"="+ encodeURIComponent(value):""));
        a.search = str.join("&");
        return a.href;
      }
      
    }

  }

  function cartpageRemlinksClickToReloadSideCart() {
    if (window.location.pathname.indexOf('/cart') !== -1) {
      let cartPageAllRemoveLinks = document.querySelector('.c-cart__remove');
      if(cartPageAllRemoveLinks.length>0) {
        cartPageAllRemoveLinks.forEach((remLink)=>{
          remLink.addEventListener('click',()=>{
            reloadCart();
          })
        });
      }
    }
  }


  function numberWithCommas(x) {
    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }

  function makePrice(x) {
    let newx = (x/100).toFixed(2);
    let theString = '$' + numberWithCommas(newx);
    return theString;
  }

  function displaySubtotal(x) {
    let subtotalEle = QC.querySelector('#quickcartsubtotal');
    if(subtotalEle) {
      subtotalEle.textContent = makePrice(x);
    }
  }

  function screenWidthCheckCloseCart(breakpoint) {
    $(window).resize(function() {
      let windowWidth = $(window).width();
      // console.log(windowWidth);
      if(windowWidth < breakpoint) {
        closeQuickCart();
      }
    });
  }
  
}


async function getCart() {
  const result = await fetch("/cart.json");
  if (result.status === 200) {
      return result.json();
  }
  throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
}


async function updateCartQty(theItemID,theNewQty) {

  let QC = document.querySelector('.quickcart');
  if(QC) {
    let listing = document.querySelector('.listing');
    let QCcartItems = QC.querySelectorAll('.entry');
    let qtySalvo = [];
    
    QCcartItems.forEach((item)=>{
      itemsID = item.dataset.itemid;
      itemsNewQty = parseInt(item.querySelector('input').value);
      qtySalvo.push(itemsNewQty);
    })

    
    jQuery.post({
      url:window.Shopify.routes.root + 'cart/update.js',
      type: 'post',
      dataType: 'json',
      data: { updates: qtySalvo },
      success: function() {
        //
      },
      error: function() {
        //
      }
    })
    
  }
}

async function removeItem(theID) {
  jQuery.post({
    url:window.Shopify.routes.root + 'cart/change.js',
    type: 'post',
    dataType: 'json',
    data: {'id': theID,'quantity': 0},
    success: function() {
      //
    },
    error: function() {
      //
    }
  })
}

async function addItem(variantId, quantity, properties = {}) {
    let formData = {
     'items': [{
      'id': variantId,
      'quantity': quantity,
       'properties': properties
      }]
    };
  
  console.log(formData);
  console.log(JSON.stringify(formData));
  
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      console.log('added');
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}





document.addEventListener("DOMContentLoaded", function(event) { 
  quickcart();
});